// import { useNavigate } from "react-router-dom";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import React, { useState, useEffect, useCallback } from "react";
// import "./DppBatchSubwiseStatus.css";
// import TableComponent from "../components/TableCompoenent";
// // import DropDown from "../../Reports/DummyReportPage/Dropdown";
// import Swal from "sweetalert2";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useLocation as useRouterLocation } from "react-router-dom";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import { startOfMonth, startOfWeek, endOfMonth, format } from "date-fns";
// // import DropDownCB from "./DropdownCB";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// // import { renderFilterField } from './renderFilter'; // Adjust the path as necessary
// import { renderFilterField } from "../components/RenderFields";
// const DppBatchSubwiseStatus = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const { state: routerState } = useRouterLocation();
//   const handleFilterApply = (filters) => {
//     // Handle filter logic here, for example, update data based on filters
//     console.log("Filters applied:", filters);
//   };
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
//   const [searchKey, setSearchKey] = useState(""); // Track the search key
//   const [batchData, setBatchData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]); // Store DPP names
//   const [subjectData, setSubjectData] = useState([]); // State for subjects
//   const [resultsData, setResultsData] = useState([]); // For storing API results
//   const [headers, setHeaders] = useState([]); // For storing table headers
//   const [isApplied, setIsApplied] = useState(false);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [resetKey, setResetKey] = useState(0); // Key to force rerender on reset
//   const [isVisible, setIsVisible] = useState(true); // Default to visible

//   const [selectedCourseId, setSelectedCourseId] = useState(""); // Single course_id (previously an array)
//   const [selectedDppIds, setSelectedDppIds] = useState([]); // For selected DPP IDs
//   const [chapterData, setChapterData] = useState([]); // State for chapters
//   const navigate = useNavigate();
//   const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table

//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     month: "Month to Date", // Set "Month to Date" as the default value
//     start_month: "",
//     end_month: "",
//     subject_id: [],
//     chapter_id: [],
//   });

//   useEffect(() => {
//     const today = new Date();
//     const firstDateOfCurrentMonth = startOfMonth(today);
//     setValues({
//       ...value,
//       start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//       end_month: format(today, "yyyy-MM-dd"),
//     });
//   }, []);

//   const [disabled, setDisabled] = useState(false);

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const fetchBatchesByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       setBatchData(data); // Set batch data from the API response
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const fetchSubjectsByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subject-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       const formattedData = data.map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));
//       setSubjectData(formattedData);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const fetchDppNamesByBatch = useCallback(
//     async (searchKey) => {
//       if (!searchKey || !selectedCourseId) return Promise.resolve([]);

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?search_key=${searchKey}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               course_ids: [selectedCourseId], // Single course_id wrapped in array
//               batch_ids: selectedBatchIds,
//               assessment_ids: selectedDppIds,
//               subject_ids: value.subject_id,
//               chapter_ids: value.chapter_id,
//             }),
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }

//         const data = await response.json();
//         return data.map((item) => ({
//           label: item.assessment_name,
//           id: item.assessment_id,
//           Option3: item.subject,
//           Option2: item.chapter,
//           Option1: item.assessment_name,
//         }));
//       } catch (error) {
//         Swal.fire({
//           title: "Error!",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//         return [];
//       }
//     },
//     [selectedCourseId, selectedBatchIds, value.subject_id, value.chapter_id]
//   );
//   const debounce = (func, delay) => {
//     let debounceTimer;
//     return function (...args) {
//       const context = this;
//       clearTimeout(debounceTimer);
//       debounceTimer = setTimeout(() => func.apply(context, args), delay);
//     };
//   };

//   const debouncedFetchDppNamesByBatch = useCallback(
//     debounce(fetchDppNamesByBatch, 300),
//     [fetchDppNamesByBatch]
//   );

//   useEffect(() => {
//     if (searchKey) {
//       debouncedFetchDppNamesByBatch(searchKey);
//     }
//   }, [searchKey, debouncedFetchDppNamesByBatch]);
//   // const debouncedFetchDppNamesByBatch = useCallback(
//   //   debounce(fetchDppNamesByBatch, 300),
//   //   [fetchDppNamesByBatch]
//   // );

//   useEffect(() => {
//     if (searchKey) {
//       debouncedFetchDppNamesByBatch(searchKey);
//     }
//   }, [searchKey, debouncedFetchDppNamesByBatch]);

//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchBatchesByCourse();
//       fetchSubjectsByCourse();
//     }
//   }, [selectedCourseId]);

//   const fetchChaptersByCourseAndSubject = async (searchKey) => {
//     if (
//       !searchKey ||
//       searchKey.length < 3 ||
//       !selectedCourseId ||
//       value.subject_id.length === 0
//     ) {
//       return Promise.resolve([]);
//     }

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapter-report-filter-searchkey/?search_key=${searchKey}&course_ids=${selectedCourseId}&subject_ids=${value.subject_id.join(
//           "&subject_ids="
//         )}`
//       );
//       const data = await response.json();

//       return data.map((item) => ({
//         label: item.chapter_name,
//         id: item.chapter_id,
//         Option2: item.subject_name,
//         Option1: item.chapter_name,
//         Option3: item.course_name,
//       }));
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return [];
//     }
//   };
//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   const handleCustomRangeChange = (e, field) => {
//     const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//     setValues({ ...value, [field]: formattedDate });
//   };

//   // const renderFilterField = (header) => {
//   //   const [type, label] = header.split("*"); // Extract type and label

//   //   switch (type) {
//   //     case "t": // For text/select inputs
//   //       return (
//   //         <div className="filter-inputs">
//   //           <label className="label-field">{label}:</label>
//   //           <select className="input-field">
//   //             <option value="0">Select car:</option>
//   //             <option value="1">Audi</option>
//   //             <option value="2">BMW</option>
//   //             <option value="3">Citroen</option>
//   //           </select>
//   //         </div>
//   //       );

//   //     case "d": // For date inputs
//   //       return (
//   //         <div className="filter-inputs">
//   //           <label className="label-field">{label}:</label>
//   //           <div className="date-input-container">
//   //             <input
//   //               type="date"
//   //               className="input-field"
//   //               onChange={(e) =>
//   //                 handleFilterApply({
//   //                   [`${label.toLowerCase()}_from`]: e.target.value,
//   //                 })
//   //               }
//   //             />
//   //             <span>To</span>
//   //             <input
//   //               type="date"
//   //               className="input-field"
//   //               onChange={(e) =>
//   //                 handleFilterApply({
//   //                   [`${label.toLowerCase()}_to`]: e.target.value,
//   //                 })
//   //               }
//   //             />
//   //           </div>
//   //         </div>
//   //       );

//   //     case "n": // For number inputs
//   //       return (
//   //         <div className="filter-inputs">
//   //           <label className="label-field">{label}:</label>
//   //           <div className="number-input-container">
//   //             <input
//   //               type="number"
//   //               className="input-field"
//   //               onChange={(e) =>
//   //                 handleFilterApply({
//   //                   [`${label.toLowerCase()}_from`]: e.target.value,
//   //                 })
//   //               }
//   //             />
//   //             <span>to</span>
//   //             <input
//   //               type="number"
//   //               className="input-field"
//   //               onChange={(e) =>
//   //                 handleFilterApply({
//   //                   [`${label.toLowerCase()}_to`]: e.target.value,
//   //                 })
//   //               }
//   //             />
//   //           </div>
//   //         </div>
//   //       );

//   //     default:
//   //       return null;
//   //   }
//   // };

//   // const renderFilterField = (header) => {
//   //   const [type, label] = header.split("*"); // Extract type and label

//   //   switch (type) {
//   //     case "t": // For text/select inputs
//   //       return (
//   //         <div className="filter-inputs">
//   //           <label className="label-field">{label}:</label>
//   //           <select className="input-field">
//   //             <option value="0">Select car:</option>
//   //             <option value="1">Audi</option>
//   //             <option value="2">BMW</option>
//   //             <option value="3">Citroen</option>
//   //           </select>
//   //         </div>
//   //       );

//   //     case "d": // For date inputs
//   //       return (
//   //         <div className="filter-inputs">
//   //           <label className="label-field">{label}:</label>
//   //           <div style={{ display: "flex", gap: "0.5rem" }}>
//   //             <input
//   //               type="date"
//   //               className="input-field"
//   //               onChange={(e) =>
//   //                 handleFilterApply({
//   //                   [`${label.toLowerCase()}_from`]: e.target.value,
//   //                 })
//   //               }
//   //             />
//   //             <span>To</span>
//   //             <input
//   //               type="date"
//   //               className="input-field"
//   //               onChange={(e) =>
//   //                 handleFilterApply({
//   //                   [`${label.toLowerCase()}_to`]: e.target.value,
//   //                 })
//   //               }
//   //             />
//   //           </div>
//   //         </div>
//   //       );

//   //     case "n": // For number inputs
//   //       return (
//   //         <div className="filter-inputs">
//   //           <label className="label-field">{label}:</label>
//   //           <div style={{ display: "flex", gap: "0.5rem" }}>
//   //             <input
//   //               type="number"
//   //               className="input-field"
//   //               onChange={(e) =>
//   //                 handleFilterApply({
//   //                   [`${label.toLowerCase()}_from`]: e.target.value,
//   //                 })
//   //               }
//   //             />
//   //             <span>to</span>
//   //             <input
//   //               type="number"
//   //               className="input-field"
//   //               onChange={(e) =>
//   //                 handleFilterApply({
//   //                   [`${label.toLowerCase()}_to`]: e.target.value,
//   //                 })
//   //               }
//   //             />
//   //           </div>
//   //         </div>
//   //       );

//   //     default:
//   //       return null;
//   //   }
//   // };

//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       // Reset only table data and headers
//       setResultsData([]); // Clear the table data
//       setHeaders([]); // Clear the headers
//       setIsApplied(false); // Set the state to not applied
//       setIsColumnDivVisible(false); // Hide the column div if necessary
//     } else {
//       // Apply logic
//       setIsApplied(true);

//       let from_date, end_date;
//       const today = new Date();

//       if (value.month === "Last Month") {
//         from_date = format(
//           startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//         end_date = format(
//           endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//       } else if (value.month === "Month to Date") {
//         from_date = format(startOfMonth(today), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Week to Date") {
//         from_date = format(
//           startOfWeek(today, { weekStartsOn: 1 }),
//           "yyyy-MM-dd"
//         );
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Custom") {
//         from_date = value.start_month;
//         end_date = value.end_month;
//       } else {
//         from_date = "2024-06-14";
//         end_date = "2024-09-14";
//       }

//       // Append the static time "10:46:01.000" to from_date and end_date
//       const from_date_with_time = `${from_date} 00:46:00`;
//       const end_date_with_time = `${end_date} 00:46:00`;

//       const postData = {
//         batch_ids: selectedBatchIds,
//         assessment_ids: selectedDppIds,
//         subject_ids: value.subject_id,
//         chapter_ids: value.chapter_id,
//       };

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-subjectwise?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
//             from_date_with_time
//           )}&end_date=${encodeURIComponent(end_date_with_time)}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(postData),
//           }
//         );

//         const data = await response.json();

//         if (!response.ok) {
//           throw new Error("Failed to fetch report data");
//         }

//         if (data.length > 0) {
//           setHeaders(data[0]);
//           setResultsData(data.slice(1));
//         } else {
//           Swal.fire({
//             title: "No Data Found",
//             text: "No results found for the selected filters.",
//             icon: "warning",
//             confirmButtonText: "OK",
//           });
//         }

//         // setIsColumnDivVisible(true);
//       } catch (error) {
//         Swal.fire({
//           title: "Error",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );

//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Are you sure you want to cancel?</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "36.5px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//             DPP batchwise and subjectwise status
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             <button
//               className="testreportcard-cancel-btn"
//               onClick={() => navigate(-1)}
//               // onClick={handleCancel}
//             >
//               CANCEL
//             </button>

//             <button
//               className="testreportcard-create-btn"
//               onClick={handleApplyOrReset}
//             >
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>{" "}
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//             View, create, or filter reports. View and manage the list of reports
//             already available or create a new report.
//           </p>

//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`course_${resetKey}`}
//             >
//               <DropDownCB
//                 label="Course"
//                 style={{ width: "13.5vw" }}
//                 selected={selectedCourseId}
//                 setSelected={setSelectedCourseId}
//                 options={
//                   coursesdata
//                     ? coursesdata.map((course) => ({
//                         id: course.course_id,
//                         label: course.course_description,
//                       }))
//                     : []
//                 }
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`batch_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Batch"
//                 width="13.5vw"
//                 selected={selectedBatchIds}
//                 setSelected={setSelectedBatchIds}
//                 options={
//                   batchData.length > 0
//                     ? batchData.map((batch) => ({
//                         label: batch.batch_name,
//                         id: batch.batch_id,
//                       }))
//                     : [{ label: "No batches available", id: "" }]
//                 }
//                 showSelectAll={true}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`test_${resetKey}`}
//             >
//               <DropDownMultipleSearchSelection
//                 label="DPP Name"
//                 width="13.5vw"
//                 customWidth="25vw"
//                 selected={selectedDppIds}
//                 setSelected={setSelectedDppIds}
//                 fetchOptions={fetchDppNamesByBatch} // Pass the search key and batch IDs
//                 options={testnamedata} // Use the formatted data
//                 showSelectAll={true}
//               />
//             </div>
//           </div>
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`subject_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Subject"
//                 width="13.5vw"
//                 selected={value.subject_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, subject_id: selectedOptions })
//                 }
//                 options={subjectData}
//                 showSelectAll={true}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`chapter_${resetKey}`}
//             >
//               <DropDownMultipleSearchSelection
//                 label="Chapter"
//                 width="13.5vw"
//                 customWidth="25vw"
//                 selected={value.chapter_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, chapter_id: selectedOptions })
//                 }
//                 fetchOptions={fetchChaptersByCourseAndSubject} // Fetch chapter data
//                 options={chapterData} // Use the formatted data with subject, chapter, and course
//                 showSelectAll={true}
//               />
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div
//             className="grid-container-radio-button"
//             style={{ ...dropdownStyle }}
//           >
//             <div className="item5">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="last month"
//                   name="month"
//                   value="Last Month"
//                   checked={value.month === "Last Month"}
//                   onChange={() => handleRadioButtonChange("Last Month")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="last month">Last Month</label>
//               </div>
//             </div>
//             <div className="item6">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="month to date"
//                   name="month"
//                   value="Month to Date"
//                   checked={value.month === "Month to Date"}
//                   onChange={() => handleRadioButtonChange("Month to Date")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="month to date">Month to Date</label>
//               </div>
//             </div>
//             <div className="item7">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="week to date"
//                   name="month"
//                   value="Week to Date"
//                   checked={value.month === "Week to Date"}
//                   onChange={() => handleRadioButtonChange("Week to Date")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="week to date">Week to Date</label>
//               </div>
//             </div>
//             <div className="item8">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="custom"
//                   name="month"
//                   value="Custom"
//                   checked={value.month === "Custom"}
//                   onChange={(e) =>
//                     setValues({ ...value, month: e.target.value })
//                   }
//                   disabled={disabled}
//                 />
//                 <label htmlFor="custom">Custom</label>
//               </div>
//             </div>

//             {value.month === "Custom" && (
//               <>
//                 <div className="item9">
//                   <FormInputs
//                     type="date"
//                     name="start_month"
//                     value={value.start_month}
//                     onChange={(e) =>
//                       setValues({ ...value, start_month: e.target.value })
//                     }
//                     disabled={isApplied}
//                   />
//                 </div>
//                 <div className="item10">To</div>
//                 <div className="item11">
//                   <FormInputs
//                     type="date"
//                     name="end_month"
//                     value={value.end_month}
//                     onChange={(e) =>
//                       setValues({ ...value, end_month: e.target.value })
//                     }
//                     disabled={isApplied}
//                   />
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//         <div style={{ position: "relative", marginTop: "20px" }}>
//           <button
//             style={{
//               position: "absolute",
//               top: "-1px",
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 1,
//               width: "60px",
//               height: "10px",
//               backgroundColor: "white",
//               // borderTopLeftRadius: "100px",
//               // borderTopRightRadius: "100px",
//               border: "none",
//               // borderBottom: "0px !important",
//             }}
//             onClick={() => {
//               setIsVisible(!isVisible);
//               setIsExpanded(!isExpanded);
//             }}
//           >
//             <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
//           </button>

//           {/* <TableComponent
//             headers={headers}
//             data={resultsData}
//             searchPlaceholder="Search records..."
//             isColumnDivVisible={isColumnDivVisible}
//             setIsColumnDivVisible={setIsColumnDivVisible}
//             dataClient={dataClient}
//             isExpanded={isExpanded}
//           >
//             <div className="filter-container" style={{padding:"10px"}}>
//               <h4 className="filter-header">Filter Options</h4>

//               {headers.map((header) => (
//                 <React.Fragment key={header}>
//                   {renderFilterField(header, handleFilterApply)}
//                 </React.Fragment>
//               ))}
//             </div>
//           </TableComponent> */}
//           <TableComponent
//             headers={headers}
//             data={resultsData}
//             searchPlaceholder="Search records..."
//             isColumnDivVisible={isColumnDivVisible}
//             setIsColumnDivVisible={setIsColumnDivVisible}
//             dataClient={dataClient}
//             isExpanded={isExpanded}
//           >
//             <div
//               className="Advance-insider-filter-container"
//               // style={{
//               //   padding: "10px",
//               //   height: "58vh",
//               //   overflowY: "auto",
//               //   marginBottom: "90px",
//               // }}
//             >
//               <h4 className="filter-header">Filter Options</h4>

//               {headers.map((header) => (
//                 <React.Fragment key={header}>
//                   {renderFilterField(header, handleFilterApply)}
//                 </React.Fragment>
//               ))}
//             </div>
//           </TableComponent>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DppBatchSubwiseStatus;

// import { useNavigate } from "react-router-dom";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import React, { useState, useEffect, useCallback } from "react";
// import "./DppBatchSubwiseStatus.css";
// import TableComponent from "../components/TableCompoenent";
// // import DropDown from "../../Reports/DummyReportPage/Dropdown";
// import Swal from "sweetalert2";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useLocation as useRouterLocation } from "react-router-dom";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import { startOfMonth, startOfWeek, endOfMonth, format } from "date-fns";
// // import DropDownCB from "./DropdownCB";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// // import { renderFilterField } from './renderFilter'; // Adjust the path as necessary
// // import { renderFilterField } from "../components/RenderFields";
// const DppBatchSubwiseStatus = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const { state: routerState } = useRouterLocation();
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
//   const [searchKey, setSearchKey] = useState(""); // Track the search key
//   const [batchData, setBatchData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]); // Store DPP names
//   const [subjectData, setSubjectData] = useState([]); // State for subjects
//   const [resultsData, setResultsData] = useState([]); // For storing API results
//   const [headers, setHeaders] = useState([]); // For storing table headers
//   const [isApplied, setIsApplied] = useState(false);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [resetKey, setResetKey] = useState(0); // Key to force rerender on reset
//   const [isVisible, setIsVisible] = useState(true); // Default to visible

//   const [selectedCourseId, setSelectedCourseId] = useState(""); // Single course_id (previously an array)
//   const [selectedDppIds, setSelectedDppIds] = useState([]); // For selected DPP IDs
//   const [chapterData, setChapterData] = useState([]); // State for chapters
//   const navigate = useNavigate();
//   const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table
//   const [originalData, setOriginalData] = useState([]); // Store original API response
//   const [filters, setFilters] = useState({}); // Track applied filters
//   const [filterValues, setFilterValues] = useState({});
//   const [filteredData, setFilteredData] = useState([]); // Store filtered data
//   // const [resultsData, setResultsData] = useState([]); // Original data
//   // const [headers, setHeaders] = useState([]); // For storing table headers
//   // const [isApplied, setIsApplied] = useState(false);
//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     month: "Month to Date", // Set "Month to Date" as the default value
//     start_month: "",
//     end_month: "",
//     subject_id: [],
//     chapter_id: [],
//   });

//   useEffect(() => {
//     const today = new Date();
//     const firstDateOfCurrentMonth = startOfMonth(today);
//     setValues({
//       ...value,
//       start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//       end_month: format(today, "yyyy-MM-dd"),
//     });
//   }, []);

//   const [disabled, setDisabled] = useState(false);

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const fetchBatchesByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       setBatchData(data); // Set batch data from the API response
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const fetchSubjectsByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subject-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       const formattedData = data.map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));
//       setSubjectData(formattedData);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const fetchDppNamesByBatch = useCallback(
//     async (searchKey) => {
//       if (!searchKey || !selectedCourseId) return Promise.resolve([]);

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?search_key=${searchKey}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               course_ids: [selectedCourseId], // Single course_id wrapped in array
//               batch_ids: selectedBatchIds,
//               assessment_ids: selectedDppIds,
//               subject_ids: value.subject_id,
//               chapter_ids: value.chapter_id,
//             }),
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }

//         const data = await response.json();
//         return data.map((item) => ({
//           label: item.assessment_name,
//           id: item.assessment_id,
//           Option3: item.subject,
//           Option2: item.chapter,
//           Option1: item.assessment_name,
//         }));
//       } catch (error) {
//         Swal.fire({
//           title: "Error!",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//         return [];
//       }
//     },
//     [selectedCourseId, selectedBatchIds, value.subject_id, value.chapter_id]
//   );
//   const debounce = (func, delay) => {
//     let debounceTimer;
//     return function (...args) {
//       const context = this;
//       clearTimeout(debounceTimer);
//       debounceTimer = setTimeout(() => func.apply(context, args), delay);
//     };
//   };

//   const debouncedFetchDppNamesByBatch = useCallback(
//     debounce(fetchDppNamesByBatch, 300),
//     [fetchDppNamesByBatch]
//   );

//   useEffect(() => {
//     if (searchKey) {
//       debouncedFetchDppNamesByBatch(searchKey);
//     }
//   }, [searchKey, debouncedFetchDppNamesByBatch]);

//   useEffect(() => {
//     if (searchKey) {
//       debouncedFetchDppNamesByBatch(searchKey);
//     }
//   }, [searchKey, debouncedFetchDppNamesByBatch]);

//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchBatchesByCourse();
//       fetchSubjectsByCourse();
//     }
//   }, [selectedCourseId]);

//   const fetchChaptersByCourseAndSubject = async (searchKey) => {
//     if (
//       !searchKey ||
//       searchKey.length < 3 ||
//       !selectedCourseId ||
//       value.subject_id.length === 0
//     ) {
//       return Promise.resolve([]);
//     }

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapter-report-filter-searchkey/?search_key=${searchKey}&course_ids=${selectedCourseId}&subject_ids=${value.subject_id.join(
//           "&subject_ids="
//         )}`
//       );
//       const data = await response.json();

//       return data.map((item) => ({
//         label: item.chapter_name,
//         id: item.chapter_id,
//         Option2: item.subject_name,
//         Option1: item.chapter_name,
//         Option3: item.course_name,
//       }));
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return [];
//     }
//   };
//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   const handleCustomRangeChange = (e, field) => {
//     const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//     setValues({ ...value, [field]: formattedDate });
//   };

//   // Apply filter logic
//   const applyFilters = () => {
//     let filtered = resultsData;
//     if (filterValues.roll_number_from || filterValues.roll_number_to) {
//       const minRoll = parseInt(filterValues.roll_number_from || 0, 10);
//       const maxRoll = parseInt(filterValues.roll_number_to || Infinity, 10);
//       filtered = filtered.filter(
//         (item) => item.roll_number >= minRoll && item.roll_number <= maxRoll
//       );
//     }
//     setFilteredData(filtered);
//   };

//   useEffect(() => {
//     applyFilters(); // Apply filters on filter values change
//   }, [filterValues]);

//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       // Reset only table data and headers
//       setResultsData([]); // Clear the table data
//       setHeaders([]); // Clear the headers
//       setIsApplied(false); // Set the state to not applied
//       setIsColumnDivVisible(false); // Hide the column div if necessary
//     } else {
//       // Apply logic
//       setIsApplied(true);

//       let from_date, end_date;
//       const today = new Date();

//       if (value.month === "Last Month") {
//         from_date = format(
//           startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//         end_date = format(
//           endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//       } else if (value.month === "Month to Date") {
//         from_date = format(startOfMonth(today), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Week to Date") {
//         from_date = format(
//           startOfWeek(today, { weekStartsOn: 1 }),
//           "yyyy-MM-dd"
//         );
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Custom") {
//         from_date = value.start_month;
//         end_date = value.end_month;
//       } else {
//         from_date = "2024-06-14";
//         end_date = "2024-09-14";
//       }

//       // Append the static time "10:46:01.000" to from_date and end_date
//       const from_date_with_time = `${from_date} 00:46:00`;
//       const end_date_with_time = `${end_date} 00:46:00`;

//       const postData = {
//         batch_ids: selectedBatchIds,
//         assessment_ids: selectedDppIds,
//         subject_ids: value.subject_id,
//         chapter_ids: value.chapter_id,
//       };

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-subjectwise?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
//             from_date_with_time
//           )}&end_date=${encodeURIComponent(end_date_with_time)}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(postData),
//           }
//         );

//         const data = await response.json();
//         setResultsData(data);
//         setFilteredData(data);
//         if (!response.ok) {
//           throw new Error("Failed to fetch report data");
//         }

//         if (data.length > 0) {
//           setHeaders(data[0]);
//           setResultsData(data.slice(1));
//         } else {
//           Swal.fire({
//             title: "No Data Found",
//             text: "No results found for the selected filters.",
//             icon: "warning",
//             confirmButtonText: "OK",
//           });
//         }

//         // setIsColumnDivVisible(true);
//       } catch (error) {
//         Swal.fire({
//           title: "Error",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );

//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Are you sure you want to cancel?</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };
//   // Define renderFilterField function
//   // Define renderFilterField function
//   const renderFilterField = (header, handleFilterApply) => {
//     const [type, label] = header.split("*"); // Extract type (n, t, d) and label

//     switch (type) {
//       case "t": // Text filter (e.g., Batch Name, Subject Name)
//         return (
//           <div className="Advance-filter-inputs">
//             <label className="Advance-label-field">{label}:</label>
//             <input
//               type="text"
//               className="Advance-input-field"
//               placeholder={`Enter ${label}`}
//               onChange={
//                 (e) => handleFilterApply(header, e.target.value) // Handle text input
//               }
//             />
//           </div>
//         );

//       case "n": // Number filter (e.g., Attempted Counts)
//         return (
//           <div className="Advance-filter-inputs">
//             <label className="Advance-label-field">{label}:</label>
//             <div className="Advance-number-input-container">
//               <input
//                 type="number"
//                 className="Advance-input-field"
//                 placeholder={`From ${label}`}
//                 onChange={(e) =>
//                   handleFilterApply(header, {
//                     ...filters[header],
//                     from: parseInt(e.target.value, 10),
//                   })
//                 }
//               />
//               <span>to</span>
//               <input
//                 type="number"
//                 className="Advance-input-field"
//                 placeholder={`To ${label}`}
//                 onChange={(e) =>
//                   handleFilterApply(header, {
//                     ...filters[header],
//                     to: parseInt(e.target.value, 10),
//                   })
//                 }
//               />
//             </div>
//           </div>
//         );

//       case "d": // Date filter
//         return (
//           <div className="Advance-filter-inputs">
//             <label className="Advance-label-field">{label}:</label>
//             <div className="Advance-date-input-container">
//               <input
//                 type="date"
//                 className="Advance-input-field"
//                 onChange={(e) =>
//                   handleFilterApply(header, {
//                     ...filters[header],
//                     from: e.target.value,
//                   })
//                 }
//               />
//               <span>to</span>
//               <input
//                 type="date"
//                 className="Advance-input-field"
//                 onChange={(e) =>
//                   handleFilterApply(header, {
//                     ...filters[header],
//                     to: e.target.value,
//                   })
//                 }
//               />
//             </div>
//           </div>
//         );

//       default:
//         return null;
//     }
//   };

//   const applyAdvanceFilters = () => {
//     let filtered = [...originalData]; // Start with the original data

//     Object.keys(filters).forEach((filterKey) => {
//       const filterValue = filters[filterKey];

//       // Check the type of filter (Number, Text, or Date)
//       const [type] = filterKey.split("*");

//       switch (type) {
//         case "n": // Number filter (e.g., Attempted Counts)
//           const minValue = filterValue?.from || 0;
//           const maxValue = filterValue?.to || Infinity;
//           filtered = filtered.filter((item) => {
//             const columnIndex = headers.findIndex(
//               (header) => header === filterKey
//             );
//             return (
//               item[columnIndex] >= minValue && item[columnIndex] <= maxValue
//             );
//           });
//           break;

//         case "t": // Text filter (e.g., Batch Name, Subject Name)
//           filtered = filtered.filter((item) => {
//             const columnIndex = headers.findIndex(
//               (header) => header === filterKey
//             );
//             return item[columnIndex]
//               .toLowerCase()
//               .includes(filterValue.toLowerCase());
//           });
//           break;

//         case "d": // Date filter
//           const fromDate = new Date(filterValue?.from || "1900-01-01");
//           const toDate = new Date(filterValue?.to || "2100-01-01");
//           filtered = filtered.filter((item) => {
//             const columnIndex = headers.findIndex(
//               (header) => header === filterKey
//             );
//             const itemDate = new Date(item[columnIndex]);
//             return itemDate >= fromDate && itemDate <= toDate;
//           });
//           break;

//         default:
//           break;
//       }
//     });

//     setFilteredData(filtered); // Update the filtered data dynamically
//   };

//   // Clear filters function
//   const clearFilters = () => {
//     setFilters({}); // Reset filters
//     setFilteredData(originalData); // Restore original data
//     setIsApplied(false); // Reset applied state
//   };

//   // Storing original data on initial load
//   useEffect(() => {
//     if (resultsData.length) {
//       setOriginalData(resultsData);
//       setFilteredData(resultsData); // Initially, filtered data is the same as original data
//     }
//   }, [resultsData]);

//   // Handle filter application dynamically
//   const handleFilterApply = (headerKey, value) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [headerKey]: value,
//     }));
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "36.5px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//             DPP batchwise and subjectwise status
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             <button
//               className="testreportcard-cancel-btn"
//               onClick={() => navigate(-1)}
//               // onClick={handleCancel}
//             >
//               CANCEL
//             </button>

//             <button
//               className="testreportcard-create-btn"
//               onClick={handleApplyOrReset}
//             >
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>{" "}
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//             View, create, or filter reports. View and manage the list of reports
//             already available or create a new report.
//           </p>

//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`course_${resetKey}`}
//             >
//               <DropDownCB
//                 label="Course"
//                 style={{ width: "13.5vw" }}
//                 selected={selectedCourseId}
//                 setSelected={setSelectedCourseId}
//                 options={
//                   coursesdata
//                     ? coursesdata.map((course) => ({
//                         id: course.course_id,
//                         label: course.course_description,
//                       }))
//                     : []
//                 }
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`batch_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Batch"
//                 width="13.5vw"
//                 selected={selectedBatchIds}
//                 setSelected={setSelectedBatchIds}
//                 options={
//                   batchData.length > 0
//                     ? batchData.map((batch) => ({
//                         label: batch.batch_name,
//                         id: batch.batch_id,
//                       }))
//                     : [{ label: "No batches available", id: "" }]
//                 }
//                 showSelectAll={true}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`test_${resetKey}`}
//             >
//               <DropDownMultipleSearchSelection
//                 label="DPP Name"
//                 width="13.5vw"
//                 customWidth="25vw"
//                 selected={selectedDppIds}
//                 setSelected={setSelectedDppIds}
//                 fetchOptions={fetchDppNamesByBatch} // Pass the search key and batch IDs
//                 options={testnamedata} // Use the formatted data
//                 showSelectAll={true}
//               />
//             </div>
//           </div>
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`subject_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Subject"
//                 width="13.5vw"
//                 selected={value.subject_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, subject_id: selectedOptions })
//                 }
//                 options={subjectData}
//                 showSelectAll={true}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`chapter_${resetKey}`}
//             >
//               <DropDownMultipleSearchSelection
//                 label="Chapter"
//                 width="13.5vw"
//                 customWidth="25vw"
//                 selected={value.chapter_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, chapter_id: selectedOptions })
//                 }
//                 fetchOptions={fetchChaptersByCourseAndSubject} // Fetch chapter data
//                 options={chapterData} // Use the formatted data with subject, chapter, and course
//                 showSelectAll={true}
//               />
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div
//             className="grid-container-radio-button"
//             style={{ ...dropdownStyle }}
//           >
//             <div className="item5">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="last month"
//                   name="month"
//                   value="Last Month"
//                   checked={value.month === "Last Month"}
//                   onChange={() => handleRadioButtonChange("Last Month")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="last month">Last Month</label>
//               </div>
//             </div>
//             <div className="item6">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="month to date"
//                   name="month"
//                   value="Month to Date"
//                   checked={value.month === "Month to Date"}
//                   onChange={() => handleRadioButtonChange("Month to Date")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="month to date">Month to Date</label>
//               </div>
//             </div>
//             <div className="item7">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="week to date"
//                   name="month"
//                   value="Week to Date"
//                   checked={value.month === "Week to Date"}
//                   onChange={() => handleRadioButtonChange("Week to Date")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="week to date">Week to Date</label>
//               </div>
//             </div>
//             <div className="item8">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="custom"
//                   name="month"
//                   value="Custom"
//                   checked={value.month === "Custom"}
//                   onChange={(e) =>
//                     setValues({ ...value, month: e.target.value })
//                   }
//                   disabled={disabled}
//                 />
//                 <label htmlFor="custom">Custom</label>
//               </div>
//             </div>

//             {value.month === "Custom" && (
//               <>
//                 <div className="item9">
//                   <FormInputs
//                     type="date"
//                     name="start_month"
//                     value={value.start_month}
//                     onChange={(e) =>
//                       setValues({ ...value, start_month: e.target.value })
//                     }
//                     disabled={isApplied}
//                   />
//                 </div>
//                 <div className="item10">To</div>
//                 <div className="item11">
//                   <FormInputs
//                     type="date"
//                     name="end_month"
//                     value={value.end_month}
//                     onChange={(e) =>
//                       setValues({ ...value, end_month: e.target.value })
//                     }
//                     disabled={isApplied}
//                   />
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//         <div style={{ position: "relative", marginTop: "20px" }}>
//           <button
//             style={{
//               position: "absolute",
//               top: "-1px",
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 1,
//               width: "60px",
//               height: "10px",
//               backgroundColor: "white",
//               // borderTopLeftRadius: "100px",
//               // borderTopRightRadius: "100px",
//               border: "none",
//               // borderBottom: "0px !important",
//             }}
//             onClick={() => {
//               setIsVisible(!isVisible);
//               setIsExpanded(!isExpanded);
//             }}
//           >
//             <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
//           </button>
//           <TableComponent
//             headers={headers}
//             data={filteredData.length ? filteredData : resultsData} // Show filtered data if filters are applied
//             searchPlaceholder="Search records..."
//             isColumnDivVisible={isColumnDivVisible}
//             setIsColumnDivVisible={setIsColumnDivVisible}
//             dataClient={dataClient}
//             isExpanded={isExpanded}
//           >
//             <div
//               className="Advance-insider-filter-container"
//               style={{
//                 padding: "10px",
//                 height: "58vh",
//                 overflowY: "auto",
//                 marginBottom: "90px",
//               }}
//             >
//               <h4 className="filter-header">Filter Options</h4>
//               <button
//                 className="testreportcard-create-btn"
//                 onClick={applyAdvanceFilters}
//               >
//                 APPLY ADVANCE FILTERS
//               </button>
//               <button
//                 className="testreportcard-cancel-btn"
//                 onClick={clearFilters}
//               >
//                 CLEAR FILTERS
//               </button>

//               {headers.map((header) => (
//                 <React.Fragment key={header}>
//                   {renderFilterField(header, handleFilterApply)}
//                 </React.Fragment>
//               ))}
//             </div>
//           </TableComponent>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DppBatchSubwiseStatus;

// import { useNavigate } from "react-router-dom";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import React, { useState, useEffect, useCallback } from "react";
// import "./DppBatchSubwiseStatus.css";
// import TableComponent from "../components/TableCompoenent";
// // import DropDown from "../../Reports/DummyReportPage/Dropdown";
// import Swal from "sweetalert2";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useLocation as useRouterLocation } from "react-router-dom";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import FormInputs from "../DummyReportPage/FormInputs";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import { startOfMonth, startOfWeek, endOfMonth, format } from "date-fns";
// // import DropDownCB from "./DropdownCB";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// // import { renderFilterField } from './renderFilter'; // Adjust the path as necessary
// // import { renderFilterField } from "../components/RenderFields";
// const DppBatchSubwiseStatus = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const { state: routerState } = useRouterLocation();
//   const [selectedBatchIds, setSelectedBatchIds] = useState([]); // For selected batch_ids
//   const [searchKey, setSearchKey] = useState(""); // Track the search key
//   const [batchData, setBatchData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]); // Store DPP names
//   const [subjectData, setSubjectData] = useState([]); // State for subjects
//   const [resultsData, setResultsData] = useState([]); // For storing API results
//   const [headers, setHeaders] = useState([]); // For storing table headers
//   const [isApplied, setIsApplied] = useState(false);
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [resetKey, setResetKey] = useState(0); // Key to force rerender on reset
//   const [isVisible, setIsVisible] = useState(true); // Default to visible

//   const [selectedCourseId, setSelectedCourseId] = useState(""); // Single course_id (previously an array)
//   const [selectedDppIds, setSelectedDppIds] = useState([]); // For selected DPP IDs
//   const [chapterData, setChapterData] = useState([]); // State for chapters
//   const navigate = useNavigate();
//   const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table
//   const [originalData, setOriginalData] = useState([]); // Store original API response
//   const [filters, setFilters] = useState({}); // Track applied filters
//   const [filterValues, setFilterValues] = useState({});
//   const [filteredData, setFilteredData] = useState([]); // Store filtered data
//   // const [resultsData, setResultsData] = useState([]); // Original data
//   // const [headers, setHeaders] = useState([]); // For storing table headers
//   // const [isApplied, setIsApplied] = useState(false);
//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: "",
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     month: "Month to Date", // Set "Month to Date" as the default value
//     start_month: "",
//     end_month: "",
//     subject_id: [],
//     chapter_id: [],
//   });

//   useEffect(() => {
//     const today = new Date();
//     const firstDateOfCurrentMonth = startOfMonth(today);
//     setValues({
//       ...value,
//       start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//       end_month: format(today, "yyyy-MM-dd"),
//     });
//   }, []);

//   const [disabled, setDisabled] = useState(false);

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const fetchBatchesByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-batch-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       setBatchData(data); // Set batch data from the API response
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const fetchSubjectsByCourse = async () => {
//     if (!selectedCourseId) return; // Ensure a single course_id is selected

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-subject-by-course-list-report-searchkey/?course_ids=${selectedCourseId}`
//       );
//       const data = await response.json();
//       const formattedData = data.map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));
//       setSubjectData(formattedData);
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   const fetchDppNamesByBatch = useCallback(
//     async (searchKey) => {
//       if (!searchKey || !selectedCourseId) return Promise.resolve([]);

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?search_key=${searchKey}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               course_ids: [selectedCourseId], // Single course_id wrapped in array
//               batch_ids: selectedBatchIds,
//               assessment_ids: selectedDppIds,
//               subject_ids: value.subject_id,
//               chapter_ids: value.chapter_id,
//             }),
//           }
//         );

//         if (!response.ok) {
//           throw new Error("Network response was not ok");
//         }

//         const data = await response.json();
//         return data.map((item) => ({
//           label: item.assessment_name,
//           id: item.assessment_id,
//           Option3: item.subject,
//           Option2: item.chapter,
//           Option1: item.assessment_name,
//         }));
//       } catch (error) {
//         Swal.fire({
//           title: "Error!",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//         return [];
//       }
//     },
//     [selectedCourseId, selectedBatchIds, value.subject_id, value.chapter_id]
//   );
//   const debounce = (func, delay) => {
//     let debounceTimer;
//     return function (...args) {
//       const context = this;
//       clearTimeout(debounceTimer);
//       debounceTimer = setTimeout(() => func.apply(context, args), delay);
//     };
//   };

//   const debouncedFetchDppNamesByBatch = useCallback(
//     debounce(fetchDppNamesByBatch, 300),
//     [fetchDppNamesByBatch]
//   );

//   useEffect(() => {
//     if (searchKey) {
//       debouncedFetchDppNamesByBatch(searchKey);
//     }
//   }, [searchKey, debouncedFetchDppNamesByBatch]);

//   useEffect(() => {
//     if (searchKey) {
//       debouncedFetchDppNamesByBatch(searchKey);
//     }
//   }, [searchKey, debouncedFetchDppNamesByBatch]);

//   useEffect(() => {
//     if (selectedCourseId) {
//       fetchBatchesByCourse();
//       fetchSubjectsByCourse();
//     }
//   }, [selectedCourseId]);

//   const fetchChaptersByCourseAndSubject = async (searchKey) => {
//     if (
//       !searchKey ||
//       searchKey.length < 3 ||
//       !selectedCourseId ||
//       value.subject_id.length === 0
//     ) {
//       return Promise.resolve([]);
//     }

//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-chapter-report-filter-searchkey/?search_key=${searchKey}&course_ids=${selectedCourseId}&subject_ids=${value.subject_id.join(
//           "&subject_ids="
//         )}`
//       );
//       const data = await response.json();

//       return data.map((item) => ({
//         label: item.chapter_name,
//         id: item.chapter_id,
//         Option2: item.subject_name,
//         Option1: item.chapter_name,
//         Option3: item.course_name,
//       }));
//     } catch (error) {
//       Swal.fire({
//         title: "Error!",
//         text: error.message,
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//       return [];
//     }
//   };
//   const handleRadioButtonChange = (selectedValue) => {
//     const today = new Date();

//     if (selectedValue === "Last Month") {
//       const firstDateLastMonth = startOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       const lastDateLastMonth = endOfMonth(
//         new Date(today.getFullYear(), today.getMonth() - 1)
//       );
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateLastMonth, "yyyy-MM-dd"),
//         end_month: format(lastDateLastMonth, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Month to Date") {
//       const firstDateOfCurrentMonth = startOfMonth(today);
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else if (selectedValue === "Week to Date") {
//       const mondayOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
//       setValues({
//         ...value,
//         month: selectedValue,
//         start_month: format(mondayOfCurrentWeek, "yyyy-MM-dd"),
//         end_month: format(today, "yyyy-MM-dd"),
//       });
//     } else {
//       setValues({ ...value, month: selectedValue });
//     }
//   };

//   const handleCustomRangeChange = (e, field) => {
//     const formattedDate = format(new Date(e.target.value), "yyyy-MM-dd");
//     setValues({ ...value, [field]: formattedDate });
//   };

//   // Apply filter logic
//   const applyFilters = () => {
//     let filtered = resultsData;
//     if (filterValues.roll_number_from || filterValues.roll_number_to) {
//       const minRoll = parseInt(filterValues.roll_number_from || 0, 10);
//       const maxRoll = parseInt(filterValues.roll_number_to || Infinity, 10);
//       filtered = filtered.filter(
//         (item) => item.roll_number >= minRoll && item.roll_number <= maxRoll
//       );
//     }
//     setFilteredData(filtered);
//   };

//   useEffect(() => {
//     applyFilters(); // Apply filters on filter values change
//   }, [filterValues]);

//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       // Reset only table data and headers
//       setResultsData([]); // Clear the table data
//       setHeaders([]); // Clear the headers
//       setIsApplied(false); // Set the state to not applied
//       setIsColumnDivVisible(false); // Hide the column div if necessary
//     } else {
//       // Apply logic
//       setIsApplied(true);

//       let from_date, end_date;
//       const today = new Date();

//       if (value.month === "Last Month") {
//         from_date = format(
//           startOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//         end_date = format(
//           endOfMonth(new Date(today.getFullYear(), today.getMonth() - 1)),
//           "yyyy-MM-dd"
//         );
//       } else if (value.month === "Month to Date") {
//         from_date = format(startOfMonth(today), "yyyy-MM-dd");
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Week to Date") {
//         from_date = format(
//           startOfWeek(today, { weekStartsOn: 1 }),
//           "yyyy-MM-dd"
//         );
//         end_date = format(today, "yyyy-MM-dd");
//       } else if (value.month === "Custom") {
//         from_date = value.start_month;
//         end_date = value.end_month;
//       } else {
//         from_date = "2024-06-14";
//         end_date = "2024-09-14";
//       }

//       // Append the static time "10:46:01.000" to from_date and end_date
//       const from_date_with_time = `${from_date} 00:46:00`;
//       const end_date_with_time = `${end_date} 00:46:00`;

//       const postData = {
//         batch_ids: selectedBatchIds,
//         assessment_ids: selectedDppIds,
//         subject_ids: value.subject_id,
//         chapter_ids: value.chapter_id,
//       };

//       try {
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-subjectwise?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
//             from_date_with_time
//           )}&end_date=${encodeURIComponent(end_date_with_time)}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify(postData),
//           }
//         );

//         const data = await response.json();
//         setResultsData(data);
//         setFilteredData(data);
//         if (!response.ok) {
//           throw new Error("Failed to fetch report data");
//         }

//         if (data.length > 0) {
//           setHeaders(data[0]);
//           setResultsData(data.slice(1));
//         } else {
//           Swal.fire({
//             title: "No Data Found",
//             text: "No results found for the selected filters.",
//             icon: "warning",
//             confirmButtonText: "OK",
//           });
//         }

//         // setIsColumnDivVisible(true);
//       } catch (error) {
//         Swal.fire({
//           title: "Error",
//           text: error.message,
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     }
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };

//   const data = resultsData.map((student) =>
//     headers.map((header, index) => student[index])
//   );

//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Are you sure you want to cancel?</span>
//         </div>
//         <div className="messagebox-insider2">
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };
//   // Define renderFilterField function
//   // Define renderFilterField function
//   const renderFilterField = (header, handleFilterApply) => {
//     const [type, label] = header.split("*"); // Extract type (n, t, d) and label

//     switch (type) {
//       case "t": // Text filter (e.g., Batch Name, Subject Name)
//         return (
//           <div className="Advance-filter-inputs">
//             <label className="Advance-label-field">{label}:</label>
//             <input
//               type="text"
//               className="Advance-input-field"
//               placeholder={`Enter ${label}`}
//               onChange={
//                 (e) => handleFilterApply(header, e.target.value) // Handle text input
//               }
//             />
//           </div>
//         );

//       case "n": // Number filter (e.g., Attempted Counts)
//         return (
//           <div className="Advance-filter-inputs">
//             <label className="Advance-label-field">{label}:</label>
//             <div className="Advance-number-input-container">
//               <input
//                 type="number"
//                 className="Advance-input-field"
//                 placeholder={`From ${label}`}
//                 onChange={(e) =>
//                   handleFilterApply(header, {
//                     ...filters[header],
//                     from: parseInt(e.target.value, 10),
//                   })
//                 }
//               />
//               <span>to</span>
//               <input
//                 type="number"
//                 className="Advance-input-field"
//                 placeholder={`To ${label}`}
//                 onChange={(e) =>
//                   handleFilterApply(header, {
//                     ...filters[header],
//                     to: parseInt(e.target.value, 10),
//                   })
//                 }
//               />
//             </div>
//           </div>
//         );

//       case "d": // Date filter
//         return (
//           <div className="Advance-filter-inputs">
//             <label className="Advance-label-field">{label}:</label>
//             <div className="Advance-date-input-container">
//               <input
//                 type="date"
//                 className="Advance-input-field"
//                 onChange={(e) =>
//                   handleFilterApply(header, { from: e.target.value })
//                 }
//               />
//               <span>to</span>
//               <input
//                 type="date"
//                 className="Advance-input-field"
//                 onChange={(e) =>
//                   handleFilterApply(header, { to: e.target.value })
//                 }
//               />
//             </div>
//           </div>
//         );

//       default:
//         return null;
//     }
//   };

//   const applyAdvanceFilters = () => {
//     let filtered = [...originalData.slice(0, 10)]; // Limit filtering to the first 10 rows

//     Object.keys(filters).forEach((filterKey) => {
//       const filterValue = filters[filterKey];

//       // Check the type of filter (Number, Text, or Date)
//       const [type] = filterKey.split("*");

//       switch (type) {
//         case "n": // Number filter (e.g., Attempted Counts)
//           const minValue = filterValue?.from || 0;
//           const maxValue = filterValue?.to || Infinity;
//           filtered = filtered.filter((item) => {
//             const columnIndex = headers.findIndex(
//               (header) => header === filterKey
//             );
//             return (
//               item[columnIndex] >= minValue && item[columnIndex] <= maxValue
//             );
//           });
//           break;

//         case "t": // Text filter (e.g., Batch Name, Subject Name)
//           filtered = filtered.filter((item) => {
//             const columnIndex = headers.findIndex(
//               (header) => header === filterKey
//             );
//             return item[columnIndex]
//               .toLowerCase()
//               .includes(filterValue.toLowerCase());
//           });
//           break;

//         case "d": // Date filter
//           const fromDate = new Date(filterValue?.from || "1900-01-01");
//           const toDate = new Date(filterValue?.to || "2100-01-01");
//           filtered = filtered.filter((item) => {
//             const columnIndex = headers.findIndex(
//               (header) => header === filterKey
//             );
//             const itemDate = new Date(item[columnIndex]);
//             return itemDate >= fromDate && itemDate <= toDate;
//           });
//           break;

//         default:
//           break;
//       }
//     });

//     setFilteredData(filtered); // Update the filtered data dynamically
//   };

//   // Clear filters function
//   const clearFilters = () => {
//     setFilters({}); // Reset filters
//     setFilteredData(originalData); // Restore original data
//     setIsApplied(false); // Reset applied state
//   };

//   // Storing original data on initial load
//   useEffect(() => {
//     if (resultsData.length) {
//       setOriginalData(resultsData);
//       setFilteredData(resultsData); // Initially, filtered data is the same as original data
//     }
//   }, [resultsData]);

//   // Handle filter application dynamically
//   const handleFilterApply = (headerKey, value) => {
//     setFilters((prevFilters) => ({
//       ...prevFilters,
//       [headerKey]: value,
//     }));
//   };

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "36.5px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//             DPP batchwise and subjectwise status
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             <button
//               className="testreportcard-cancel-btn"
//               onClick={() => navigate(-1)}
//               // onClick={handleCancel}
//             >
//               CANCEL
//             </button>

//             <button
//               className="testreportcard-create-btn"
//               onClick={handleApplyOrReset}
//             >
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>{" "}
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//             View, create, or filter reports. View and manage the list of reports
//             already available or create a new report.
//           </p>

//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`course_${resetKey}`}
//             >
//               <DropDownCB
//                 label="Course"
//                 style={{ width: "13.5vw" }}
//                 selected={selectedCourseId}
//                 setSelected={setSelectedCourseId}
//                 options={
//                   coursesdata
//                     ? coursesdata.map((course) => ({
//                         id: course.course_id,
//                         label: course.course_description,
//                       }))
//                     : []
//                 }
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`batch_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Batch"
//                 width="13.5vw"
//                 selected={selectedBatchIds}
//                 setSelected={setSelectedBatchIds}
//                 options={
//                   batchData.length > 0
//                     ? batchData.map((batch) => ({
//                         label: batch.batch_name,
//                         id: batch.batch_id,
//                       }))
//                     : [{ label: "No batches available", id: "" }]
//                 }
//                 showSelectAll={true}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`test_${resetKey}`}
//             >
//               <DropDownMultipleSearchSelection
//                 label="DPP Name"
//                 width="13.5vw"
//                 customWidth="25vw"
//                 selected={selectedDppIds}
//                 setSelected={setSelectedDppIds}
//                 fetchOptions={fetchDppNamesByBatch} // Pass the search key and batch IDs
//                 options={testnamedata} // Use the formatted data
//                 showSelectAll={true}
//               />
//             </div>
//           </div>
//           <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`subject_${resetKey}`}
//             >
//               <DropDownMultipleSelection
//                 label="Subject"
//                 width="13.5vw"
//                 selected={value.subject_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, subject_id: selectedOptions })
//                 }
//                 options={subjectData}
//                 showSelectAll={true}
//               />
//             </div>
//             <div
//               className="col-cs2"
//               style={{ marginRight: "1vw", ...dropdownStyle }}
//               key={`chapter_${resetKey}`}
//             >
//               <DropDownMultipleSearchSelection
//                 label="Chapter"
//                 width="13.5vw"
//                 customWidth="25vw"
//                 selected={value.chapter_id}
//                 setSelected={(selectedOptions) =>
//                   setValues({ ...value, chapter_id: selectedOptions })
//                 }
//                 fetchOptions={fetchChaptersByCourseAndSubject} // Fetch chapter data
//                 options={chapterData} // Use the formatted data with subject, chapter, and course
//                 showSelectAll={true}
//               />
//             </div>
//           </div>
//         </div>
//         <div
//           style={{
//             display: isVisible ? "block" : "none",
//             marginTop: "1vh",
//           }}
//         >
//           <div
//             className="grid-container-radio-button"
//             style={{ ...dropdownStyle }}
//           >
//             <div className="item5">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="last month"
//                   name="month"
//                   value="Last Month"
//                   checked={value.month === "Last Month"}
//                   onChange={() => handleRadioButtonChange("Last Month")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="last month">Last Month</label>
//               </div>
//             </div>
//             <div className="item6">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="month to date"
//                   name="month"
//                   value="Month to Date"
//                   checked={value.month === "Month to Date"}
//                   onChange={() => handleRadioButtonChange("Month to Date")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="month to date">Month to Date</label>
//               </div>
//             </div>
//             <div className="item7">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="week to date"
//                   name="month"
//                   value="Week to Date"
//                   checked={value.month === "Week to Date"}
//                   onChange={() => handleRadioButtonChange("Week to Date")}
//                   disabled={disabled}
//                 />
//                 <label htmlFor="week to date">Week to Date</label>
//               </div>
//             </div>
//             <div className="item8">
//               <div className="toggle-radio">
//                 <input
//                   type="radio"
//                   id="custom"
//                   name="month"
//                   value="Custom"
//                   checked={value.month === "Custom"}
//                   onChange={(e) =>
//                     setValues({ ...value, month: e.target.value })
//                   }
//                   disabled={disabled}
//                 />
//                 <label htmlFor="custom">Custom</label>
//               </div>
//             </div>

//             {value.month === "Custom" && (
//               <>
//                 <div className="item9">
//                   <FormInputs
//                     type="date"
//                     name="start_month"
//                     value={value.start_month}
//                     onChange={(e) =>
//                       setValues({ ...value, start_month: e.target.value })
//                     }
//                     disabled={isApplied}
//                   />
//                 </div>
//                 <div className="item10">To</div>
//                 <div className="item11">
//                   <FormInputs
//                     type="date"
//                     name="end_month"
//                     value={value.end_month}
//                     onChange={(e) =>
//                       setValues({ ...value, end_month: e.target.value })
//                     }
//                     disabled={isApplied}
//                   />
//                 </div>
//               </>
//             )}
//           </div>
//         </div>
//         <div style={{ position: "relative", marginTop: "20px" }}>
//           <button
//             style={{
//               position: "absolute",
//               top: "-1px",
//               left: "50%",
//               transform: "translateX(-50%)",
//               zIndex: 1,
//               width: "60px",
//               height: "10px",
//               backgroundColor: "white",
//               // borderTopLeftRadius: "100px",
//               // borderTopRightRadius: "100px",
//               border: "none",
//               // borderBottom: "0px !important",
//             }}
//             onClick={() => {
//               setIsVisible(!isVisible);
//               setIsExpanded(!isExpanded);
//             }}
//           >
//             <p style={{ fontSize: "20px", color: "black" }}>. . .</p>
//           </button>
//           <TableComponent
//             headers={headers}
//             data={filteredData.length ? filteredData : resultsData} // Show filtered data if filters are applied
//             searchPlaceholder="Search records..."
//             isColumnDivVisible={isColumnDivVisible}
//             setIsColumnDivVisible={setIsColumnDivVisible}
//             dataClient={dataClient}
//             isExpanded={isExpanded}
//           >
//             <div
//               className="Advance-insider-filter-container"
//               style={{
//                 padding: "10px",
//                 height: "58vh",
//                 overflowY: "auto",
//                 marginBottom: "90px",
//               }}
//             >
//               <h4 className="filter-header">Filter Options</h4>
//               <button
//                 className="testreportcard-create-btn"
//                 onClick={applyAdvanceFilters}
//               >
//                 APPLY ADVANCE FILTERS
//               </button>
//               <button
//                 className="testreportcard-cancel-btn"
//                 onClick={clearFilters}
//               >
//                 CLEAR FILTERS
//               </button>

//               {headers.map((header) => (
//                 <React.Fragment key={header}>
//                   {renderFilterField(header, handleFilterApply)}
//                 </React.Fragment>
//               ))}
//             </div>
//           </TableComponent>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DppBatchSubwiseStatus;

// import React, { useState, useEffect, useCallback } from "react";
// import TableCompoenent from "../components/TableCompoenent";
// import { API_BASE_URL } from "../../../Config/Config";
// import { useDispatch, useSelector } from "react-redux";
// import Swal from "sweetalert2";
// import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
// import DropDownCB from "../../CreateBatch/DropdownCB";
// import FormInputs from "../DummyReportPage/FormInputs";
// import dayjs from "dayjs";
// import DropDownMultipleSelection from "../components/FieldsComponent";
// import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
// import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
// import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
// import { useNavigate } from "react-router-dom";

// const StudentDPPSummary = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   pauseTimer,
//   resumeTimer,
//   dataClient,
// }) => {
//   const dispatch = useDispatch();
//   const { coursesdata } = useSelector((state) => state.course);
//   const [resultsData, setResultsData] = useState([]);
//   const [headers, setHeaders] = useState([]);
//   const [chapterData, setChapterData] = useState([]);
//   const [batchData, setBatchData] = useState([]);
//   const [subjectData, setSubjectData] = useState([]);
//   const [testnamedata, setTestNameData] = useState([]);
//   const [isApplied, setIsApplied] = useState(false);
//   const [resetKey, setResetKey] = useState(0);
//   const [selectedBatches, setSelectedBatches] = useState([]);
//   const [selectedDppIds, setSelectedDppIds] = useState([]);
//   const [selectedStudentIds, setSelectedStudentIds] = useState([]); // For students
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [isVisible, setIsVisible] = useState(true); // For toggling sections visibility
//   const [disabled, setDisabled] = useState(false); // For controlling dropdown disabling
//   const [selectedBatchName, setSelectedBatchName] = useState("");
//   const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students
//   const [studentData, setStudentData] = useState([]); // State to hold fetched students
//   const [testname, setTestName] = useState([]); // This will store the fetched DPP names
//   const [chapterName, setChapterName] = useState([]);
//   const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table
//   const [selectedSubjects, setSelectedSubjects] = useState([]);
//   const [filteredSubjects, setFilteredSubjects] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [apiData, setApiData] = useState([]);
//   const [selectedChapters, setSelectedChapters] = useState([]);

//   const [value, setValues] = useState({
//     report_title: "",
//     course_id: "",
//     batch_id: [],
//     assessment_id: "",
//     assessment_name: "",
//     description: "",
//     subject_id: [],
//     chapter_id: [],
//     month: "Month to Date", // Default value set to "Month to Date"
//     start_month: "",
//     end_month: "",
//   });

//   useEffect(() => {
//     dispatch(fetchCourseData());
//   }, [dispatch]);

//   const calculateDates = () => {
//     const today = dayjs();
//     let from_date = "";
//     let end_date = today.format("YYYY-MM-DD HH:mm:ss");

//     switch (value.month) {
//       case "Last Month":
//         from_date = today
//           .subtract(1, "month")
//           .startOf("month")
//           .format("YYYY-MM-DD HH:mm:ss");
//         end_date = today
//           .subtract(1, "month")
//           .endOf("month")
//           .format("YYYY-MM-DD HH:mm:ss");
//         break;
//       case "Month to Date":
//         from_date = today.startOf("month").format("YYYY-MM-DD HH:mm:ss");
//         break;
//       case "Week to Date":
//         from_date = today.startOf("week").format("YYYY-MM-DD HH:mm:ss");
//         break;
//       case "Custom":
//         const current_time = today.format("HH:mm:ss");
//         from_date = `${value.start_month} 00:00:00`;
//         end_date = `${value.end_month} ${current_time}`;
//         break;
//       default:
//         break;
//     }
//     return { from_date, end_date };
//   };

//   const { from_date, end_date } = calculateDates();

//   const fetchDppPerformanceData = async () => {
//     const { from_date, end_date } = calculateDates();
//     if (!value.course_id) {
//       // Swal.fire({
//       //   title: "Error",
//       //   text: "Please select a course.",
//       //   icon: "error",
//       //   confirmButtonText: "OK",
//       // });
//       setResultsData([]);

//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer}
//           onMouseLeave={resumeTimer}
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Please Select a Course</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       return;
//     }

//     const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-student-dpp-report-summary?course_id=${
//       value.course_id
//     }&from_date=${encodeURIComponent(from_date)}&end_date=${encodeURIComponent(
//       end_date
//     )}`;

//     try {
//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           batch_ids: selectedBatches,
//           student_ids: selectedStudentIds,
//           subject_ids: selectedSubjects,
//           chapter_ids: selectedChapters,
//         }),
//       });

//       const data = await response.json();
//       if (data && data.length > 0) {
//         setHeaders(data[0]); // Set headers
//         setResultsData(data.slice(1)); // Set results
//       } else {
//         // Swal.fire({
//         //   title: "No Data",
//         //   text: "No report data found for the selected filters.",
//         //   icon: "info",
//         //   confirmButtonText: "OK",
//         // });
//         setResultsData([]);

//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div
//             className="Container-messageBOX"
//             onMouseEnter={pauseTimer}
//             onMouseLeave={resumeTimer}
//           >
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>No report data found for the selected filters.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//       }
//     } catch (error) {
//       // Swal.fire({
//       //   title: "Error",
//       //   text: error.message,
//       //   icon: "error",
//       //   confirmButtonText: "OK",
//       // });
//       setResultsData([]);

//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer}
//           onMouseLeave={resumeTimer}
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//   useEffect(() => {
//     if (value.course_id) {
//       fetchSubjectsAndBatchesByCourse();
//     }
//   }, [value.course_id]);

//   useEffect(() => {
//     if (selectedBatches.length > 0) {
//       filterSubjectsByBatch();
//     } else if (selectedSubjects.length > 0) {
//       filterBatchesBySubject();
//     } else {
//       resetFilters();
//     }
//   }, [selectedBatches, selectedSubjects]);

//   const fetchSubjectsAndBatchesByCourse = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=${value.course_id}`,
//         {
//           method: "POST",
//           headers: {
//             accept: "application/json",
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             batch_ids: [], // Initially empty, can be filled if needed
//             assessment_ids: [],
//             subject_ids: [],
//             chapter_ids: [],
//           }),
//         }
//       );
//       const data = await response.json();
//       setApiData(data); // Store full API data

//       // Extract unique batches and subjects
//       const uniqueBatches = [];
//       const uniqueSubjects = [];

//       data.forEach((item) => {
//         if (!uniqueBatches.find((batch) => batch.id === item.batch_id)) {
//           uniqueBatches.push({ label: item.batch_name, id: item.batch_id });
//         }
//         if (!uniqueSubjects.find((subject) => subject.id === item.subject_id)) {
//           uniqueSubjects.push({
//             label: item.subject_name,
//             id: item.subject_id,
//           });
//         }
//       });

//       setBatchData(uniqueBatches);
//       setFilteredBatches(uniqueBatches); // Initially show all batches
//       setSubjectData(uniqueSubjects);
//       setFilteredSubjects(uniqueSubjects); // Initially show all subjects
//     } catch (error) {
//       // Swal.fire({
//       //   title: "Error",
//       //   text: error.message,
//       //   icon: "error",
//       //   confirmButtonText: "OK",
//       // });
//       setResultsData([]);

//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer}
//           onMouseLeave={resumeTimer}
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//   const filterSubjectsByBatch = () => {
//     const filtered = apiData
//       .filter((item) => selectedBatches.includes(item.batch_id))
//       .map((item) => ({
//         label: item.subject_name,
//         id: item.subject_id,
//       }));

//     const uniqueFilteredSubjects = filtered.filter(
//       (value, index, self) =>
//         index === self.findIndex((subject) => subject.id === value.id)
//     ); // Ensure subjects are unique
//     setFilteredSubjects(uniqueFilteredSubjects);
//   };

//   const filterBatchesBySubject = () => {
//     const filtered = apiData
//       .filter((item) => selectedSubjects.includes(item.subject_id))
//       .map((item) => ({
//         label: item.batch_name,
//         id: item.batch_id,
//       }));

//     const uniqueFilteredBatches = filtered.filter(
//       (value, index, self) =>
//         index === self.findIndex((batch) => batch.id === value.id)
//     ); // Ensure batches are unique
//     setFilteredBatches(uniqueFilteredBatches);
//   };

//   const resetFilters = () => {
//     setFilteredBatches(batchData); // Reset to show all batches
//     setFilteredSubjects(subjectData); // Reset to show all subjects
//   };
//   // const chpater= "chapter"
//   // Step 1: Consolidate assessments with the same assessment_id for dropdown display

//   const consolidateDppNames = (data) => {
//     const uniqueDppNames = {};
//     data.forEach((item) => {
//       if (!uniqueDppNames[item.assessment_id]) {
//         uniqueDppNames[item.assessment_id] = {
//           label: item.assessment_name,
//           assessment_id: item.assessment_id,
//           Option1: item.assessment_name,
//           Option2: item.subject_name,
//           Option3: item.course_name,
//           assessment_assignment_ids: [item.assessment_assignment_id], // Store all the assignment IDs with the same assessment_id
//           Headers1: "Assessment Name",
//           Headers2: "Subject Name",
//           Headers3: "Course Name",
//         };
//       } else {
//         // Add the assignment ID if it belongs to the same assessment_id
//         uniqueDppNames[item.assessment_id].assessment_assignment_ids.push(
//           item.assessment_assignment_id
//         );
//       }
//     });
//     return Object.values(uniqueDppNames); // Return the consolidated list of DPP names
//   };

//   const fetchDppNamesByBatch = async (searchKey) => {
//     if (!searchKey || !value.course_id) {
//       return Promise.resolve([]); // Return empty if no course ID or searchKey
//     }

//     try {
//       const url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=${value.course_id}&search_key=${searchKey}&search_column=dpp`;

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           batch_ids: selectedBatches.length > 0 ? selectedBatches : [],
//           subject_ids: selectedSubjects.length > 0 ? selectedSubjects : [],
//           chapter_ids: selectedChapters.length > 0 ? selectedChapters : [],
//         }),
//       });

//       const data = await response.json();

//       // Step 1: Consolidate the DPP names by assessment_id
//       const consolidatedDppData = {};
//       data.forEach((item) => {
//         if (!consolidatedDppData[item.assessment_id]) {
//           consolidatedDppData[item.assessment_id] = {
//             label: item.assessment_name, // Show assessment name
//             id: item.assessment_id, // Use assessment_id as the identifier
//             Option1: item.assessment_name, // Display assessment name
//             Option2: item.subject_name, // Display subject name
//             Option3: item.course_name, // Display course name
//             Headers1: "Assessment Name",
//             Headers2: "Subject Name",
//             Headers3: "Course Name",
//             assessment_assignment_ids: [item.assessment_assignment_id], // Store assignment IDs
//           };
//         } else {
//           // If assessment_id already exists, push the new assignment_id into the array
//           consolidatedDppData[
//             item.assessment_id
//           ].assessment_assignment_ids.push(item.assessment_assignment_id);
//         }
//       });

//       // Convert the consolidated object into an array
//       const formattedDppData = Object.values(consolidatedDppData);

//       return formattedDppData; // Return the consolidated data for the dropdown
//     } catch (error) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer}
//           onMouseLeave={resumeTimer}
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       return [];
//     }
//   };

//   const fetchChaptersBySubject = async (searchKey) => {
//     if (!searchKey || searchKey.length < 3 || !value.course_id) {
//       return Promise.resolve([]); // Return empty if no course ID or searchKey
//     }

//     try {
//       let url = `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey/?course_id=${value.course_id}&search_key=${searchKey}&search_column=chapter`;

//       const response = await fetch(url, {
//         method: "POST",
//         headers: {
//           accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           batch_ids: selectedBatches.length > 0 ? selectedBatches : [],
//           assessment_ids: [],
//           subject_ids: selectedSubjects.length > 0 ? selectedSubjects : [],
//           chapter_ids: [],
//         }),
//       });

//       const data = await response.json();

//       // Format and set chapters, subjects, and batches
//       const formattedChapters = [];
//       const formattedSubjects = [];
//       const formattedBatches = [];

//       data.forEach((item) => {
//         // Filter unique chapters
//         if (
//           !formattedChapters.find((chapter) => chapter.id === item.chapter_id)
//         ) {
//           formattedChapters.push({
//             label: item.chapter_name,
//             id: item.chapter_id,
//             Option1: item.chapter_name,
//             Option2: item.subject_name,
//             Option3: item.course_name,
//             Headers1: "Chapter Name",
//             Headers2: "Subject Name",
//             Headers3: "Course Name",
//           });
//         }

//         // Filter unique subjects
//         if (
//           !formattedSubjects.find((subject) => subject.id === item.subject_id)
//         ) {
//           formattedSubjects.push({
//             label: item.subject_name,
//             id: item.subject_id,
//           });
//         }

//         // Filter unique batches
//         if (!formattedBatches.find((batch) => batch.id === item.batch_id)) {
//           formattedBatches.push({
//             label: item.batch_name,
//             id: item.batch_id,
//           });
//         }
//       });

//       setChapterName(formattedChapters); // Set the chapter data
//       setFilteredSubjects(formattedSubjects); // Set the subject data
//       setFilteredBatches(formattedBatches); // Set the batch data

//       return formattedChapters;
//     } catch (error) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer}
//           onMouseLeave={resumeTimer}
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//       return [];
//     }
//   };

//   const handleApplyOrReset = async () => {
//     if (isApplied) {
//       // Reset logic: clear all data and reset the form
//       setResultsData([]); // Clear the table data
//       setHeaders([]); // Clear the headers
//       setIsApplied(false); // Set the state to not applied
//       setIsColumnDivVisible(false); // Hide the column div if necessary
//       setDisabled(false); // Enable dropdowns
//       setResetKey((prevKey) => prevKey + 1); // Trigger key change to reset components

//       // Retain the selected course, batch, chapter, subject, and date values
//       setValues((prevValues) => ({
//         ...prevValues,
//         report_title: "",
//         assessment_id: "",
//         assessment_name: "",
//         description: "",
//         month: prevValues.month,
//         start_month: prevValues.start_month,
//         end_month: prevValues.end_month,
//         course_id: prevValues.course_id,
//         batch_id: prevValues.batch_id,
//         subject_id: prevValues.subject_id,
//         chapter_id: prevValues.chapter_id, // Keep the chapter_id value
//       }));
//     } else {
//       // Apply logic: fetch the data using the new API
//       setIsApplied(true);
//       setDisabled(true); // Disable dropdowns
//       const { from_date, end_date } = calculateDates();

//       try {
//         // Get the selected assessment assignment IDs based on the selected assessment IDs
//         const selectedAssessmentAssignmentIds = selectedDppIds
//           .map((assessmentId) => {
//             const selectedAssessment = testname.find((dpp) => dpp.id === assessmentId);
//             return selectedAssessment ? selectedAssessment.assessment_assignment_ids : [];
//           })
//           .flat(); // Flatten the array to ensure all IDs are sent correctly

//         // Make the API call with selected assessment_assignment_ids, subject_ids, batch_ids, and chapter_ids from value
//         const response = await fetch(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-subjectwise?course_id=${value.course_id}&from_date=${encodeURIComponent(from_date)}&end_date=${encodeURIComponent(end_date)}`,
//           {
//             method: "POST",
//             headers: {
//               accept: "application/json",
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               batch_ids: selectedBatches.length > 0 ? selectedBatches : [],   // Send selected batch_ids
//               subject_ids: selectedSubjects.length > 0 ? selectedSubjects : [], // Send selected subject_ids
//               chapter_ids: value.chapter_id.length > 0 ? value.chapter_id : [], // Use value.chapter_id for selected chapter_ids
//               assessment_ids: selectedDppIds.length > 0 ? selectedDppIds : [], // Send selected assessment_assignment_ids
//             }),
//           }
//         );

//         const data = await response.json();
//         if (data && data.length > 0) {
//           setHeaders(data[0]); // Set headers from API response
//           setResultsData(data.slice(1)); // Set the table data from API response
//         } else {
//           setResultsData([]); // If no data, clear the table

//           setIsMessageBoxVisible(true);
//           setMessageBox(
//             <div
//               className="Container-messageBOX"
//               onMouseEnter={pauseTimer}
//               onMouseLeave={resumeTimer}
//             >
//               <div className="messagebox-insider1">
//                 <div className="loader-tc"></div>
//                 <span>No report data found for the selected filters.</span>
//               </div>
//             </div>
//           );
//           setActiveImg(InterogativeImg);
//         }
//       } catch (error) {
//         setResultsData([]); // Clear table data on error

//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div
//             className="Container-messageBOX"
//             onMouseEnter={pauseTimer}
//             onMouseLeave={resumeTimer}
//           >
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>{error.message}</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//       }
//     }
//   };

//   const fetchResultsData = async () => {
//     try {
//       const response = await fetch(
//         `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-result-dictionary-v2/?assessment_id=${value.assessment_id}`
//       );
//       const data = await response.json();
//       if (data.data.length === 0) {
//         // Swal.fire({
//         //   title: "No Data",
//         //   text: "Report data for the selected filters not found.",
//         //   icon: "warning",
//         //   confirmButtonText: "OK",
//         // });
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div
//             className="Container-messageBOX"
//             onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//             onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//           >
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Report data for the selected filters not found.</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//       } else {
//         setHeaders(data.data[0]);
//         setResultsData(data.data.slice(1));
//       }
//       // setIsColumnDivVisible(true);
//     } catch (error) {
//       // Swal.fire({
//       //   title: "Error",
//       //   text: error.message,
//       //   icon: "error",
//       //   confirmButtonText: "OK",
//       // });
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div
//           className="Container-messageBOX"
//           onMouseEnter={pauseTimer} // Use the pauseTimer passed from props
//           onMouseLeave={resumeTimer} // Use the resumeTimer passed from props
//         >
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>{error.message}</span>
//           </div>
//         </div>
//       );
//       setActiveImg(InterogativeImg);
//     }
//   };

//   const handleCancel = () => {
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           width: "82vw",
//           marginTop: "2.3vh",
//         }}
//       >
//         <div style={{ display: "flex", width: "50vw" }}>
//           <div className="loader-tc"></div>
//           <span style={{ marginLeft: "10px", marginTop: "3px" }}>
//             Are you sure you want to cancel?
//           </span>
//         </div>
//         <div
//           style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
//         >
//           <button
//             className="messagebox-cancel-btn"
//             style={{ marginRight: "10px" }}
//             onClick={() => setIsMessageBoxVisible(false)}
//           >
//             CANCEL
//           </button>
//           <button
//             className="testreportcard-create-btn"
//             onClick={() => window.location.reload()}
//           >
//             PROCEED
//           </button>
//         </div>
//       </div>
//     );

//     setTimeout(function () {
//       setIsMessageBoxVisible(false);
//     }, 9000);

//     setActiveImg(InterogativeImg);
//   };

//   const dropdownStyle = isApplied
//     ? { opacity: 0.5, pointerEvents: "none" }
//     : { opacity: 1, pointerEvents: "auto" };
//   const navigate = useNavigate();

//   const maxChapterLength = 136;
//   const chapter = (() => {
//     // If no chapters are selected, assume "All" chapters are selected
//     if (
//       value.chapter_id.length === 0 ||
//       value.chapter_id.length === chapterName.length
//     ) {
//       return "chapter"; // Case when no chapters or all chapters are selected
//     }

//     // Get the full chapter string by joining selected chapters (if chapters are selected)
//     const chapterString = chapterName
//       .filter((chapter) => value.chapter_id.includes(chapter.id))
//       .map((chapter) => chapter.label)
//       .join(", ");

//     if (chapterString.length > maxChapterLength) {
//       // If the string exceeds the limit, show "Multiple"
//       return "Multiple";
//     } else {
//       // If the length is within the limit, return the full string
//       return chapterString;
//     }
//   })();

//   const maxStudentLength = 129;
//   const student = (() => {
//     if (
//       selectedStudents.length === 0 ||
//       selectedStudents.length === studentData.length
//     ) {
//       return "All";
//     }
//     const studentString = selectedStudents
//       .map((student) => `${student.roll_no}`)
//       .join(", ");

//     if (studentString.length > maxStudentLength) {
//       return "Multiple";
//     } else {
//       return studentString;
//     }
//   })();

//   const maxDppLength = 136;
//   const dppName = (() => {
//     if (
//       selectedDppIds.length === 0 ||
//       selectedDppIds.length === testname.length
//     ) {
//       return "All";
//     }
//     const dppString = testname
//       .filter((dpp) => selectedDppIds.includes(dpp.id))
//       .map((dpp) => dpp.label)
//       .join(", ");

//     if (dppString.length > maxDppLength) {
//       return "Multiple";
//     } else {
//       return dppString;
//     }
//   })();

//   const maxSubjectLength = 136;
//   const subject = (() => {
//     if (
//       value.subject_id.length === 0 ||
//       value.subject_id.length === subjectData.length
//     ) {
//       return "All";
//     }

//     const subjectString = subjectData
//       .filter((subject) => value.subject_id.includes(subject.id))
//       .map((subject) => subject.label)
//       .join(", ");

//     if (subjectString.length > maxSubjectLength) {
//       return "Multiple";
//     } else {
//       return subjectString;
//     }
//   })();

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "36.5px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0" }}>
//         <div className="Header-up">
//           <span style={{ color: "#2F2E40", fontSize: "30px" }}>
//           DPP batchwise and subjectwise status
//           </span>
//           <div
//             className="testreportcard-header-btn-container"
//             style={{ marginRight: "30px" }}
//           >
//             <button
//               className="testreportcard-cancel-btn"
//               // onClick={handleCancel}
//               onClick={() => navigate(-1)}
//             >
//               CANCEL
//             </button>

//             <button
//               className="testreportcard-create-btn"
//               onClick={handleApplyOrReset}
//             >
//               {isApplied ? "RESET" : "APPLY"}
//             </button>
//           </div>
//         </div>
//       </div>
//       <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>
//         <div className="row-cs-uni">
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`course_${resetKey}`}
//           >
//             <DropDownCB
//               label="Course"
//               width="13.5vw"
//               selected={value.course_id}
//               setSelected={(selectedOption) =>
//                 setValues({ ...value, course_id: selectedOption })
//               }
//               options={
//                 coursesdata?.length > 0
//                   ? coursesdata.map((course) => ({
//                       label: course.course_description,
//                       id: course.course_id,
//                     }))
//                   : [{ label: "No Course available", id: "" }]
//               }
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`batch_${resetKey}`}
//           >
//             <DropDownMultipleSelection
//               label="Batch"
//               width="13.5vw"
//               selected={selectedBatches}
//               setSelected={setSelectedBatches}
//               options={filteredBatches} // Filtered batch data
//               showSelectAll={true}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`student_${resetKey}`}
//           >
//             <DropDownMultipleSearchSelection
//               label="DPP Name"
//               width="13.5vw"
//               customWidth="25vw"
//               selected={selectedDppIds} // Bind selected values to state
//               setSelected={(selectedOptions) => {
//                 // Ensure selected options are valid assessment IDs and update state
//                 const validSelectedDppIds = selectedOptions.filter((option) =>
//                   Number.isInteger(option)
//                 );
//                 setSelectedDppIds(validSelectedDppIds); // Set the selected DPPs in state
//               }}
//               fetchOptions={fetchDppNamesByBatch} // Fetch DPP names using the fetch function
//               options={testname || []} // Options to display in dropdown
//               showSelectAll={true}
//               keepOpen={true} // Keep dropdown open after selecting multiple items
//             />
//           </div>
//         </div>
//         <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`subject_${resetKey}`}
//           >
//             <DropDownMultipleSelection
//               label="Subject"
//               width="13.5vw"
//               selected={selectedSubjects}
//               setSelected={setSelectedSubjects}
//               options={filteredSubjects} // Filtered subject data
//               showSelectAll={true}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`chapter_${resetKey}`}
//           >
//             <DropDownMultipleSearchSelection
//               label="Chapter"
//               width="13.5vw"
//               customWidth="25vw"
//               selected={value.chapter_id}
//               setSelected={(selectedOptions) => {
//                 const selectedChapterDetails = chapterData.filter((chapter) =>
//                   selectedOptions.includes(chapter.id)
//                 );
//                 setValues({
//                   ...value,
//                   chapter_id: selectedOptions, // Store the selected chapter IDs
//                 });
//               }}
//               fetchOptions={fetchChaptersBySubject}
//               options={chapterData || []} // Display the chapter data
//               showSelectAll={true}
//             />
//           </div>
//           <div
//             className="col-cs2"
//             style={{ marginRight: "1vw", ...dropdownStyle }}
//             key={`dpp_${resetKey}`}
//           ></div>
//         </div>
//         <div
//           className="grid-container-radio-button"
//           style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
//         >
//           <div className="item5">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="last month"
//                 name="month"
//                 value="Last Month"
//                 checked={value.month === "Last Month"}
//                 onChange={(e) => setValues({ ...value, month: e.target.value })}
//                 disabled={isApplied}
//               />
//               <label htmlFor="last month">Previous Month</label>
//             </div>
//           </div>
//           <div className="item6">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="month to date"
//                 name="month"
//                 value="Month to Date"
//                 checked={value.month === "Month to Date"} // Ensures "Month to Date" is selected by default
//                 onChange={(e) => setValues({ ...value, month: e.target.value })}
//                 disabled={isApplied}
//               />
//               <label htmlFor="month to date">Month to Date</label>
//             </div>
//           </div>
//           <div className="item7">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="week to date"
//                 name="month"
//                 value="Week to Date"
//                 checked={value.month === "Week to Date"}
//                 onChange={(e) => setValues({ ...value, month: e.target.value })}
//                 disabled={isApplied}
//               />
//               <label htmlFor="week to date">Week to Date</label>
//             </div>
//           </div>
//           <div className="item8">
//             <div className="toggle-radio">
//               <input
//                 type="radio"
//                 id="custom"
//                 name="month"
//                 value="Custom"
//                 checked={value.month === "Custom"}
//                 onChange={(e) => setValues({ ...value, month: e.target.value })}
//                 disabled={isApplied}
//               />
//               <label htmlFor="custom">Custom</label>
//             </div>
//           </div>
//           {value.month === "Custom" && (
//             <>
//               <div className="item9">
//                 <FormInputs
//                   type="date"
//                   name="start_month"
//                   value={value.start_month}
//                   onChange={(e) =>
//                     setValues({ ...value, start_month: e.target.value })
//                   }
//                   disabled={isApplied}
//                 />
//               </div>
//               <div className="item10">To</div>
//               <div className="item11">
//                 <FormInputs
//                   type="date"
//                   name="end_month"
//                   value={value.end_month}
//                   onChange={(e) =>
//                     setValues({ ...value, end_month: e.target.value })
//                   }
//                   disabled={isApplied}
//                 />
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//       <div style={{ position: "relative", marginTop: "20px" }}>
//         <button
//           style={{
//             position: "absolute",
//             top: "-1px",
//             left: "50%",
//             transform: "translateX(-50%)",
//             zIndex: 1,
//             width: "60px",
//             height: "10px",
//             backgroundColor: "white",
//             border: "none",
//           }}
//           onClick={() => {
//             setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
//             setIsVisible(!isVisible);
//           }}
//         >
//           <p style={{ fontSize: "20px", color: "black" }}>...</p>
//         </button>
//         <TableCompoenent
//           headers={headers.map((header) => header.substring(2))}
//           data={resultsData}
//           searchPlaceholder="Search by Student Name..."
//           isColumnDivVisible={isColumnDivVisible}
//           setIsColumnDivVisible={setIsColumnDivVisible}
//           dataClient={dataClient}
//           ReportPageHeader="Student DPP Performance"
//           course={
//             coursesdata?.find((course) => course.course_id === value.course_id)
//               ?.course_description || ""
//           }
//           batch={selectedBatchName}
//           student={student}
//           subject={subject}
//           dppName={dppName}
//           date={
//             from_date &&
//             end_date &&
//             dayjs(from_date).isValid() &&
//             dayjs(end_date).isValid()
//               ? `${dayjs(from_date).format("YYYY-MM-DD")} To ${dayjs(
//                   end_date
//                 ).format("YYYY-MM-DD HH:mm:ss")}`
//               : ""
//           }
//           chapter={chapter}
//           isExpanded={isExpanded} // Pass the new isExpanded prop
//         />
//       </div>
//     </div>
//   );
// };

// export default StudentDPPSummary;

import TableCompoenent from "../components/TableCompoenent";
import { API_BASE_URL } from "../../../Config/Config";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CustomSearchDropdown from "../../POP/FileComp5";
import _ from "lodash";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import FormInputs from "../DummyReportPage/FormInputs";
import DropDownMultipleSelection from "../components/FieldsComponent";
import DropDownCB from "../components/SingleDropdwon";
import { format, startOfMonth, endOfMonth, startOfWeek } from "date-fns";
const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
  // Remove duplicates from the array
  return _.uniqBy(
    dataArray.map((item) => ({
      id: item[idField],
      label: item[nameField],
    })),
    "id"
  );
};

const StudentDPPSummary = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
}) => {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [resultsData, setResultsData] = useState([]);
  const [headers, setHeaders] = useState([]);
  // const [searchKey, setSearchKey] = useState(""); // State for search key
  const [testnamedata, setTestNameData] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]); // For students
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true); // For toggling sections visibility
  const [disabled, setDisabled] = useState(false); // For controlling dropdown disabling
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const [testname, setTestName] = useState([]); // This will store the fetched DPP names
  const [chapterName, setChapterName] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [dppData, setDppData] = useState([]);
  const [studentData, setStudentData] = useState([]); // New state for student dropdown
  const [selectedCourseId, setSelectedCourseId] = useState(" ");
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [selectedDppIds, setSelectedDppIds] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students
  // const [searchColumn, setSearchColumn] = useState(null); // search column
  const [searchKey, setSearchKey] = useState(""); // State for search key
  const [searchColumn, setSearchColumn] = useState(""); // Initially null for search column

  const [value, setValues] = useState({
    report_title: "",
    course_id: "",
    batch_id: "",
    assessment_id: "",
    assessment_name: "",
    description: "",
    month: "",
    start_month: "",
    month: "Month to Date",
    end_month: "",
    subject_id: [], // Initialize as an empty array
    chapter_id: [], // Initialize as an empty array    month: "",
    start_month: "",
    end_month: "",
    subject_id: [],
    chapter_id: [],
  });
  const [searchParams] = useSearchParams();
  const reportName = searchParams.get("reportName");

  useEffect(() => {
    if (selectedCourseId) {
      fetchDropdownData(); // Call only when selectedCourseId is updated and valid
    }
  }, [selectedCourseId]); // Trigger fetchDropdownData when selectedCourseId changes

  const fetchDropdownData = useCallback(async () => {
    try {
      if (!selectedCourseId) throw new Error("No course selected");

      const response = await fetch(
        `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            batch_ids: selectedBatches,
            subject_ids: selectedSubjects,
            chapter_ids: selectedChapters,
            assessment_ids: selectedDppIds,
            student_ids: selectedStudents,
            search_key: searchKey,
            search_column: searchColumn,
          }),
        }
      );
      const data = await response.json();

      setBatchData(
        mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
      );
      setSubjectData(
        mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name")
      );
      const uniqueChapters = _.uniqBy(data.chapter_list, "chapter_id");
      setChapterData(
        uniqueChapters.map((item) => ({
          id: item.chapter_id,
          chapter_name: item.chapter_name, // Field for Chapter Name
          subject_name: item.subject_name, // Field for Subject Name
          // batch_name: item.batch_name, // Field for Batch Name
        }))
      );
      const uniqueAssessments = _.uniqBy(
        data.assessment_list.filter(
          (assessment) => assessment.assessment_type_id === 1
        ),
        "assessment_id"
      );

      setDppData(
        uniqueAssessments.map((item) => ({
          id: item.assessment_id,
          assessment_name: item.assessment_name,
          chapter_name: item.chapter_name,
          subject_name: item.subject_name,
        }))
      );

      setStudentData(
        mapDataToDropdownFormat(data.student_list, "student_id", "student_name")
      );
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }, [
    selectedCourseId,
    selectedBatches,
    selectedSubjects,
    selectedChapters,
    selectedDppIds,
    selectedStudents,
    searchKey,
    searchColumn,
  ]);

  const handleSearchKeyChange = (key, dropdownType) => {
    if (
      dropdownType === "chapter" ||
      dropdownType === "dpp" ||
      dropdownType === "student"
    ) {
      if (key.length >= 3) {
        setSearchKey(key);
        setSearchColumn(dropdownType);
      } else {
        setSearchKey("");
        setSearchColumn("");
      }
    } else {
      setSearchKey("");
      setSearchColumn("");
    }
  };

  // Triggers when the dropdown is closed and initiates API call
  const handleDropdownClose = () => {
    fetchDropdownData();
  };

  // Maximum length for string truncation (optional)
  const maxLength = 136;

  const student = (() => {
    // If no students are selected or all are selected
    if (
      selectedStudents.length === 0 ||
      selectedStudents.length === studentData.length
    ) {
      return "All";
    }

    // Get the full student string by joining selected student names or roll numbers
    const studentString = selectedStudents
      .map((student) => student.label)
      .join(", ");

    return studentString.length > maxLength ? "Multiple" : studentString;
  })();

  const subject = (() => {
    // If no subjects are selected or all are selected
    if (
      selectedSubjects.length === 0 ||
      selectedSubjects.length === subjectData.length
    ) {
      return "All";
    }

    // Get the full subject string by joining selected subject names
    const subjectString = selectedSubjects
      .map((subject) => subject.label)
      .join(", ");

    return subjectString.length > maxLength ? "Multiple" : subjectString;
  })();

  const dppName = (() => {
    // If no DPPs are selected or all are selected
    if (
      selectedDppIds.length === 0 ||
      selectedDppIds.length === dppData.length
    ) {
      return "All";
    }
    // Get the full DPP string by joining selected DPP names
    const dppString = selectedDppIds.map((dpp) => dpp.label).join(", ");

    return dppString.length > maxLength ? "Multiple" : dppString;
  })();

  // Update the searchKey and searchColumn based on the dropdown interaction
  const [apiTriggered, setApiTriggered] = useState(false); // New flag to control API trigger

  const calculateDates = () => {
    const today = dayjs();
    let from_date = "";
    let end_date = today.format("YYYY-MM-DD HH:mm:ss");

    switch (value.month) {
      case "Last Month":
        from_date = today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        end_date = today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Month to Date":
        from_date = today.startOf("month").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Week to Date":
        from_date = today.startOf("week").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Custom":
        const current_time = today.format("HH:mm:ss");
        from_date = `${value.start_month} 00:00:00`;
        end_date = `${value.end_month} ${current_time}`;
        break;
      default:
        break;
    }
    return { from_date, end_date };
  };

  const { from_date, end_date } = calculateDates();

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };
  const navigate = useNavigate();

  useEffect(() => {
    const today = new Date();
    const firstDateOfCurrentMonth = startOfMonth(today);
    setValues({
      ...value,
      start_month: format(firstDateOfCurrentMonth, "yyyy-MM-dd"),
      end_month: format(today, "yyyy-MM-dd"),
    });
  }, []);

  // const [disabled, setDisabled] = useState(false);
  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  const handleApplyOrReset = async () => {
    if (isApplied) {
      // Reset logic
      setResultsData([]);
      setHeaders([]);
      setIsApplied(false);
      setIsColumnDivVisible(false);
      // Do not reset the selected values for batches, subjects, chapters, DPPs, and students
    } else {
      // Apply logic
      setIsApplied(true);
      const { from_date, end_date } = calculateDates();

      // Ensure selected data is not null, and filter out any undefined/null values
      const postData = {
        batch_ids: selectedBatches, // Send selected batch IDs directly
        subject_ids: selectedSubjects, // Send selected subject IDs directly
        chapter_ids: selectedChapters, // Send selected chapter IDs directly
        assessment_ids: selectedDppIds, // Send selected DPP IDs directly
        student_ids: selectedStudents, // Send selected student IDs directly
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-dpp-report-subjectwise?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
            from_date
          )}&end_date=${encodeURIComponent(end_date)}`,
          {
            method: "POST",
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(postData), // Send postData in the body of the request
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error("Failed to fetch report data");
        }

        if (data.length > 0) {
          setHeaders(data[0]);
          setResultsData(data.slice(1));
        } else {
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <span>No results found for the selected filters.</span>
              </div>
            </div>
          );
          setActiveImg(InterogativeImg);
        }
      } catch (error) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>{error.message}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
      }
    }
  };

  const course =
    coursesdata && coursesdata.length > 0
      ? coursesdata.find((course) => course.course_id === selectedCourseId)
        ?.course_description || ""
      : "";

  const getSelectedBatchNames = () => {
    if (selectedBatches.length === 0) return 'All';
    const batchNames = batchData
      .filter((batch) => selectedBatches.includes(batch.id)) // Filter based on selected batch IDs
      .map((batch) => batch.label); // Extract batch names
    return batchNames.join(', '); // Join them as a comma-separated string
  };

  const getSelectedSubjectNames = () => {
    if (selectedSubjects.length === 0) return 'All';
    const subjectNames = subjectData
      .filter((subject) => selectedSubjects.includes(subject.id))
      .map((subject) => subject.label);
    return subjectNames.join(', ');
  };

  const getSelectedChapterNames = () => {
    if (selectedChapters.length === 0) return 'All';
    const chapterNames = chapterData
      .filter((chapter) => selectedChapters.includes(chapter.id)) // Filter based on selected chapter IDs
      .map((chapter) => chapter.chapter_name); // Extract chapter names
    const chapterNamesString = chapterNames.join(', '); // Join them as a comma-separated string
    const maxBatchLength = 129; // Maximum character limit for display
    // If the length of the chapter names string exceeds the maxBatchLength, show "Multiple chapters selected"
    if (chapterNamesString.length > maxBatchLength) {
      return 'Multiple';
    }
    return chapterNamesString;
  };

  const getSelectedStudentRollNumbers = () => {
    if (selectedStudents.length === 0) return 'All';
    const rollNumbers = studentData
      .filter((student) => selectedStudents.includes(student.id))
      .map((student) => student.roll_number);
    const rollNumbersString = rollNumbers.join(', ');
    const maxBatchLength = 129;
    if (rollNumbersString.length > maxBatchLength) {
      return 'Multiple';
    }
    return rollNumbersString;
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span
            style={{
              color: "#2F2E40",
              fontSize: "30px",
              textTransform: "capitalize",
            }}
          >
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              // onClick={handleCancel}
              onClick={() => navigate(-1)}
            >
              CANCEL
            </button>

            <button
              className="testreportcard-create-btn"
              onClick={handleApplyOrReset}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
      </div>
      <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>
        <div className="row-cs-uni">
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`course_${resetKey}`}
          >
            <DropDownCB
              label="Course"
              style={{ width: "13.5vw" }}
              selected={selectedCourseId}
              setSelected={setSelectedCourseId}
              options={
                coursesdata
                  ? coursesdata.map((course) => ({
                    id: course.course_id,
                    label: course.course_description,
                  }))
                  : []
              }
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`batch_${resetKey}`}
          >
            <DropDownMultipleSelection
              label="Select Batch"
              width="13vw"
              selected={selectedBatches}
              setSelected={setSelectedBatches}
              options={batchData}
              showSelectAll={true}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              isRequired={false}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`student_${resetKey}`}
          >
            <CustomSearchDropdown
              label="Select DPP"
              optionsData={dppData}
              selected={selectedDppIds}
              setSelected={setSelectedDppIds}
              placeholder="Search for DPP..."
              headers={["Assessment Name", "Chapter Name", "Subject Name"]}
              optionFields={{
                option1: "assessment_name",
                option2: "chapter_name",
                option3: "subject_name",
              }}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              customwidth="30vw"
            />
          </div>
        </div>
        <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`subject_${resetKey}`}
          >
            <DropDownMultipleSelection
              width="13.5vw"
              label="Select Subject"
              selected={selectedSubjects}
              setSelected={setSelectedSubjects}
              options={subjectData}
              customWidth="100%"
              isRequired={false}
              showSelectAll={true}
              onDropdownClose={handleDropdownClose}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`chapter_${resetKey}`}
          >
            <CustomSearchDropdown
              label="Select Chapter"
              optionsData={chapterData}
              selected={selectedChapters}
              setSelected={setSelectedChapters}
              placeholder="Search for Chapter..."
              headers={["Chapter Name", "Subject Name"]}
              optionFields={{
                option1: "chapter_name",
                option2: "subject_name",
                // option3: "batch_name",
              }}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              customwidth="20vw"
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`dpp_${resetKey}`}
          ></div>
        </div>
        <div
          className="grid-container-radio-button"
          style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
        >
          <div className="item5">
            <div className="toggle-radio">
              <input
                type="radio"
                id="last month"
                name="month"
                value="Last Month"
                checked={value.month === "Last Month"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="last month">Previous Month</label>
            </div>
          </div>
          <div className="item6">
            <div className="toggle-radio">
              <input
                type="radio"
                id="month to date"
                name="month"
                value="Month to Date"
                checked={value.month === "Month to Date"} // Ensures "Month to Date" is selected by default
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="month to date">Month to Date</label>
            </div>
          </div>
          <div className="item7">
            <div className="toggle-radio">
              <input
                type="radio"
                id="week to date"
                name="month"
                value="Week to Date"
                checked={value.month === "Week to Date"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="week to date">Week to Date</label>
            </div>
          </div>
          <div className="item8">
            <div className="toggle-radio">
              <input
                type="radio"
                id="custom"
                name="month"
                value="Custom"
                checked={value.month === "Custom"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="custom">Custom</label>
            </div>
          </div>
          {value.month === "Custom" && (
            <>
              <div className="item9">
                <FormInputs
                  type="date"
                  name="start_month"
                  value={value.start_month}
                  onChange={(e) =>
                    setValues({ ...value, start_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
              <div className="item10">To</div>
              <div className="item11">
                <FormInputs
                  type="date"
                  name="end_month"
                  value={value.end_month}
                  onChange={(e) =>
                    setValues({ ...value, end_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div style={{ position: "relative", marginTop: "20px" }}>
        <button
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
            width: "60px",
            height: "10px",
            backgroundColor: "white",
            border: "none",
          }}
          onClick={() => {
            setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
            setIsVisible(!isVisible);
          }}
        >
          <p style={{ fontSize: "20px", color: "black" }}>...</p>
        </button>
        <TableCompoenent
          headers={headers.map((header) => header.substring(2))}
          data={resultsData}
          searchPlaceholder="Search by Student Name..."
          isColumnDivVisible={isColumnDivVisible}
          setIsColumnDivVisible={setIsColumnDivVisible}
          dataClient={dataClient}
          ReportPageHeader={reportName}
          course={course}
          batch={getSelectedBatchNames()}
          subject={getSelectedSubjectNames()}
          chapter={getSelectedChapterNames()}
          student={getSelectedStudentRollNumbers()}
          dppName={dppName}
          date={
            from_date &&
              end_date &&
              dayjs(from_date).isValid() &&
              dayjs(end_date).isValid()
              ? `${dayjs(from_date).format("YYYY-MM-DD")} To ${dayjs(
                end_date
              ).format("YYYY-MM-DD HH:mm:ss")}`
              : ""
          }
          isExpanded={isExpanded} // Pass the new isExpanded prop
        />
      </div>
    </div>
  );
};

export default StudentDPPSummary;
